import { useOutletContext, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import type { TrainingsTraining } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

import { UploadCertificate } from 'modules/trainings/components/MyTrainings/UploadCertificate'

const EmployeesTrainingCertificateUpload = () => {
  const { id } = useParams()
  const { training, employeeAccessId } = useOutletContext<{
    training: TrainingsTraining
    employeeAccessId: number
  }>()
  const { navigation } = useNavigation()

  return (
    <UploadCertificate
      navigateBackTo={navigation.employees.id.training.detail.view.fullPath({
        id: String(id),
        trainingId: training.id,
      })}
      accessId={employeeAccessId}
    />
  )
}

export default EmployeesTrainingCertificateUpload
